import BaseApiRequest from "./BaseApiRequest";
import { METHOD } from "../Constants";
import { FILE_LIST_URL } from "../ApiUrls";
import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class FileListRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  url = FILE_LIST_URL;

  body = {};

  constructor(
    id,
    page = 0,
    size = 20,
    fileType = null,
    sortBy = "uploadedAt",
    sortDirection = "DESC"
  ) {
    super();
    this.body = {
      id,
      page,
      size,
      sortBy,
      sortDirection,
    };
    if (fileType) {
      this.body.fileType = fileType;
    }
  }

  getMethod = () => this.method;

  // eslint-disable-next-line class-methods-use-this
  getUrl = () => {
    const baseUrl = this.url;
    const params = new URLSearchParams();

    Object.keys(this.body).forEach((key) => {
      if (this.body[key] !== null && this.body[key] !== undefined) {
        params.append(key, this.body[key]);
      }
    });

    return `${baseUrl}?${params.toString()}`;
  };

  getBody = () => ({});
}
